document.addEventListener('livewire:load', function () {
    const livewireComponent = document.querySelector('[wire\\:id]');
    const idComponent = livewireComponent.getAttribute('wire:id');
    const principalComponent = Livewire.find(idComponent);
    $('#country, #state, #city').select2();

    $('#country').on('change', function () {
        principalComponent.set('country', $(this).val());
        principalComponent.set('state', '');
        principalComponent.set('city', '');

        Livewire.emit('getStates');
    });
    $('#state').on('change', function () {
        principalComponent.set('state', $(this).val());
        principalComponent.set('city', '');
        Livewire.emit('getCities');
    });
    $('#city').on('change', function () {
        principalComponent.set('city', $(this).val());

    });

    Livewire.hook('message.processed', function(){
        $('#country, #state, #city').select2();
    });

    Livewire.on('validateCaptcha', function(){
        if ($("#register-form").find(".g-recaptcha").length) {
            const widget_id = $(this).find(".g-recaptcha").attr("data-tabindex");
            const responseCaptcha = grecaptcha.getResponse(widget_id);
            if (responseCaptcha.length <= 0) {
                const pathname = window.location.pathname;
                const final = pathname.split("/", 2);
                const lang = final[1];
                Swal.fire({
                    title: "Captcha",
                    text: (lang == 'es') ? "Por favor, confirma que eres humano" : "Please ensure that you are a human",
                    icon: "warning",
                    confirmButtonColor: "#0075DB"
                });
    
                return false;
            }

            principalComponent.set('captcha', true);
            principalComponent.set('g_recaptcha_response', $('.g-recaptcha-response').val());

            return;
        }
    });

    Livewire.on('successForm', function(data) {
        const pathname = window.location.pathname;
        const final = pathname.split("/", 2);
        const lang = final[1];

        if (data.hasOwnProperty('has_record') && data.has_record) {
            Swal.fire({
                title: (lang == 'es') ? 'La agencia ya existe' : 'The agency already exists',
                html: (lang == 'es') ? 'El RFC proporcionado ya se encuentra registrado. Intenta con un RFC diferente.' : 'The RFC provided is already registered. Try a different RFC.',
                confirmButtonColor: '#1990FF',
                icon: "error",
            });
        } else {
            Swal.fire({
                title: (lang == 'es') ? 'Registro completo' : 'Complete registration',
                html: (lang == 'es') ? 'Gracias por haberte registrado con nosotros. En breve uno de nuestros ejecutivos comerciales se contactará contigo.' : 'Thank you for registering with us. One of our commercial executives will contact you shortly.',
                confirmButtonColor: '#1990FF',
                icon: "success",
            });
        }


        grecaptcha.reset();
    });
});